import { t, jt } from 'ttag'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import styled, { css } from 'styled-components'

import { features } from '@h2/components/media'
import { Flex } from '@h2/components/layout/flex'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Link } from '@h2/common/components/link'
import { WHITE } from '@h2/components/colors'
import { Globals } from '@h2/globals'
import accountCreationSvg from '@h2/assets/svg/illustrations/accountCreation.svg'
import navigatorAccountSvg from '@h2/assets/svg/illustrations/navigatorAccount.svg'
import navianceLinkedAccountSvg from '@h2/assets/svg/illustrations/navianceLinkedAccount.svg'
import explorerSvg from '@h2/assets/svg/illustrations/explore.svg'

import { Wrap } from './components'

const HighlightWrap = styled(Wrap)`
  ${({ isNavianceUser }) =>
    isNavianceUser &&
    css`
      & h2,
      & p {
        text-align: center;
      }
    `}
`
const FlexWrap = styled(Flex)`
  ${({ isNavianceUser }) =>
    isNavianceUser &&
    css`
      flex-direction: column;
      align-items: center;
    `}
`
const FlexWrapBottom = styled(Flex)`
  flex-direction: row !important;
  justify-content: center;
`
const Image = styled.img`
  width: 115px;
  height: auto;

  ${({ isNavianceUser }) =>
    isNavianceUser &&
    css`
      width: 215px;
    `}

  @media (${features.minWidth.laptop}) {
    width: 100%;
  }
`
const PSLink = styled(Link)`
  margin-top: 30px;
  & + & {
    border-left: 1px solid ${WHITE};
    padding-left: 4px;
    margin-left: 4px;
  }
`
const types = {
  unknown: {
    name: '',
    svg: accountCreationSvg
  },
  explorer: {
    name: <span key="jt-exp">{t`Explorer`}</span>,
    svg: explorerSvg
  },
  navigator: {
    name: <span key="jt-nav">{t`Navigator`}</span>,
    svg: navigatorAccountSvg
  },
  navianceUser: {
    name: <span key="jt-navUser">{t`Naviance User`}</span>,
    svg: navianceLinkedAccountSvg
  }
}
const Create = ({ isNamePanel = false, type = 'unknown', inRegistration = true }) => {
  const { isNavianceUser } = useContext(Globals)
  const privacyStatement = t`Privacy statement`
  const termsStatement = t`Terms of use`

  return (
    <HighlightWrap isNavianceUser={isNavianceUser} isNamePanel={isNamePanel}>
      <Heading level="2" color="white" id="modal-title">
        {type === 'navianceUser' &&
          inRegistration === false &&
          jt`Link your Headed2 account to Naviance!`}
        {type === 'navianceUser' &&
          inRegistration === true &&
          jt`Create an account to link to Naviance!`}
        {type !== 'navianceUser' && jt`Create an ${types[type].name} account`}
      </Heading>
      <FlexWrap isNavianceUser={isNavianceUser}>
        <Text color="white" margin="0">
          {type === 'navianceUser' &&
            t`Link your Naviance and Headed2 accounts to access Headed2 features in Naviance.`}
          {type !== 'navianceUser' &&
            t`A Headed2 account lets you save what you're working on, so you can come back at any point. It only takes a minute, so get started now.`}
        </Text>
        <Image isNavianceUser={isNavianceUser} src={types[type].svg} alt="" />
      </FlexWrap>
      <FlexWrapBottom>
        <PSLink ssr={true} href="https://www.powerschool.com/privacy">
          <Text color="white">{privacyStatement}</Text>
        </PSLink>
        <PSLink ssr={true} href="https://www.powerschool.com/terms/">
          <Text color="white">{termsStatement}</Text>
        </PSLink>
      </FlexWrapBottom>
    </HighlightWrap>
  )
}

Create.propTypes = {
  isNamePanel: PropTypes.bool,
  type: PropTypes.oneOf(['unknown', 'explorer', 'navigator', 'navianceUser']),
  inRegistration: PropTypes.bool
}

export { Create }
